import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useUserSettingsContext } from '../context/UserSettingsContext';
import LoadingScreen from './LoadingScreen';
import tokenRefreshManager from '../utils/tokenRefresh';
import { rememberDeepLink } from '../utils/deepLink';

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const { fetchSettings, userSettings } = useUserSettingsContext();
  const location = useLocation();

  React.useEffect(() => {
    checkAuth();
  }, []);
  

  async function checkAuth() {
    try {
      // Use token refresh manager to ensure we have a valid token
      const session = await tokenRefreshManager.ensureValidToken();
      const token = session.tokens.accessToken;
      
      if (!token) {
        throw new Error('No token found');
      }

      setIsAuthenticated(true);
      
      // Fetch user settings after successful authentication (by email). Login
      // has already loaded them when we arrive from the sign-in flow — a second
      // fetch here only held the skeleton up and re-rendered the shell.
      if (!userSettings?.email) await fetchSettings();
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <LoadingScreen message="Connecting" />;
  }

  if (!isAuthenticated) {
    // Resume here after sign-in (report email links land signed-out).
    rememberDeepLink(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/login" replace />;
  }

  return children || <Outlet />;
}

export default ProtectedRoute; 